<!-- results-table.component.html -->
<h1 mat-dialog-title><strong [translate]="action">{{action | translate}}</strong> dimension riesgo <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">
    <!--<div fxFlex>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list" fxFlex>
        <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
      </mat-form-field>
    </div>-->

    <div fxFlex>
      <mat-form-field fxFlex *ngIf="action != 'Delete'">
        <mat-label>Nombre</mat-label>
        <input
               placeholder="Nombre"
               aria-label="Nombre"
               matInput
               [readonly]="action == 'View'"
               [matAutocompleteDisabled]="action == 'View'"
               [formControl]="myControl"
               [matAutocomplete]="auto"
               [(ngModel)]="dimension">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="setLocal($event.option.value)">
                <mat-option *ngFor="let dimension of filteredDimensiones | async" [value]="dimension">
                  {{dimension.nombre}}
                </mat-option>
              </mat-autocomplete>

      </mat-form-field>
    </div>

    <div fxFlex>
      <mat-form-field *ngIf="action != 'Delete'" fxFlex>
        <mat-label>Descripción</mat-label>
        <!--<textarea placeholder="Descripcion" matInput [(ngModel)]="LOCAL_DATA.descripcion" >
        </textarea>-->

        <textarea
              [disabled] ="action == 'View'"
              matInput [(ngModel)]="LOCAL_DATA.descripcion"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"></textarea>
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field class="chip-list" *ngIf="action != 'Delete'" fxFlex>
          <mat-label>Categorias</mat-label>
          <mat-chip-list #chipList aria-label="Categorias" >
          <mat-chip *ngFor="let categoria of LOCAL_DATA.categorias" [selectable]="selectable"
                   [removable]="removable" (removed)="remove(categoria)">
                   {{categoria}}
            <mat-icon matChipRemove *ngIf="removable && action != 'View'">cancel</mat-icon>
          </mat-chip>
          <input placeholder="Nueva categoria..."
                 [matChipInputFor]="chipList"
                 [disabled] ="action == 'View'"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 [matChipInputAddOnBlur]="addOnBlur"
                 (matChipInputTokenEnd)="add($event)">
          </mat-chip-list>
      </mat-form-field>

    </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
